import Swiper from 'swiper';
import { A11y, Autoplay, FreeMode } from 'swiper/modules';

export function initPartnersSlider() {
  const sectionEl = document.querySelector('.home-partners');
  if (!sectionEl) {
    return;
  }

  const sliderEl = sectionEl.querySelector('.home-partners__slider');
  if (!sliderEl) {
    return;
  }

  const slides = sliderEl.querySelectorAll('.swiper-slide');
  if (slides.length === 0) {
    return;
  }

  const isEnoughSlides = slides.length >= 6;

  new Swiper(sliderEl, {
    modules: [A11y, Autoplay, FreeMode],
    slidesPerView: 2,
    spaceBetween: 24,
    centerInsufficientSlides: true,
    speed: 4000,
    loop: isEnoughSlides,
    autoplay: isEnoughSlides
      ? {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }
      : false,
    freeMode: isEnoughSlides,
    allowTouchMove: isEnoughSlides,
    breakpoints: {
      640: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 6,
        spaceBetween: 24,
      },
    },
    a11y: {
      firstSlideMessage: 'To jest pierwszy slajd',
      lastSlideMessage: 'To jest ostatni slajd',
    },
  });
}
